module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-32-c78b48f33e91d9faf0d8cdf5bbf160b5.png";